import imagesloaded from 'imagesloaded';
import { default as ReactFlickityComponent } from 'react-flickity-component';

const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

class FlickityComponent extends ReactFlickityComponent {
  componentDidMount() {
    // Copied from ReactFlickityComponent, but uses PatchedFlickity.
    if (!canUseDOM) return null;
    const PatchedFlickity = require('../../utils/flickity').default;
    const { flickityRef, options } = this.props;
    this.flkty = new PatchedFlickity(this.carousel, options);
    if (flickityRef) flickityRef(this.flkty);
    if (this.props.static) {
      this.setReady();
    } else {
      this.setState({ flickityCreated: true });
    }
    this.flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
      this.flkty.select(cellIndex);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Copied from ReactFlickityComponent, but calls resize instead of
    // reloadCells since it does some additional work. This will possibly break
    // it if additional cells are added, but we can worry about that when we have
    // a use case for it.
    const {
      children,
      options: { draggable, initialIndex },
      reloadOnUpdate,
      disableImagesLoaded,
    } = this.props;
    const { flickityReady } = this.state;
    if (reloadOnUpdate || (!prevState.flickityReady && flickityReady)) {
      const isActive = this.flkty.isActive;
      this.flkty.deactivate();
      this.flkty.selectedIndex = initialIndex || 0;
      this.flkty.options.draggable =
        draggable === undefined ? (children ? children.length > 1 : false) : draggable;
      if (isActive) this.flkty.activate();
      if (!disableImagesLoaded && this.carousel) {
        imagesloaded(this.carousel, () => {
          this.flkty.resize();
        });
      }
    } else {
      this.flkty.resize();
    }
  }
}

export default FlickityComponent;
